<template>
    <div
        id="main-panel"
        class=" px-4 md:px-10 pt-8 pb-20 w-full h-full flex flex-col flex-grow justify-center" 
        :style="{ 'background-color': bgColor }"
      >
    <div
      ref="chooser"
      v-on-clickaway="closeChooser"
      class="content-chooser absolute top-60 left-0 bg-gray-100 p-1 rounded-r-lg border border-solid border-gray-200 mt-2 z-10"
    >
      <div
        ref="chooserButton"
        @click="chooserVisible = !chooserVisible"
        class="mx-auto my-auto h-5 w-5"
      >
        <svg-icon
          v-if="chooserVisible"
          icon="heroicons/solid/minus"
          class="h-5 w-5 cursor-pointer text-gray-300 hover:text-gray-700"
        />

        <svg-icon
          v-else
          icon="heroicons/outline/plus"
          class="h-5 w-5 cursor-pointer text-gray-500 hover:text-gray-700"
        />
      </div>

      <draggable
        v-if="chooserVisible"
        :list="contentList"
        ghost-class="chooser-ghost"
        @start="onDragStart"
        @end="onDragEnd"
        :group="{ name: 'content', pull: 'clone', put: false }"
      >
        <div
          class="flex flex-col p-2"
          v-for="element in contentList"
          :key="element.id"
        >
          <div
            class="border border-solid border-gray-200 cursor-pointer w-15 h-15 bg-white rounded flex flex-col items-center justify-center hover:shadow-md"
          >
            <div
              class="text-blue-400 p-1 rounded-full flex flex-col justify-center items-center"
              v-tooltip="{ content: (element.name || element.type), placement: 'right' }"
            >
              <span class="material-icons">
                {{ getIcon(element.type) }}
              </span>
            </div>
          </div>
        </div>
      </draggable>
    </div>

    <!-- Rows Start -->

    <draggable
      v-model="rows"
      :group="{ name: 'row', pull: false, put: false }"
      handle=".row-handle"
      draggable=".draggable-row"
      :key="step.id"
      @start="onDragStart"
      @end="onDragEnd"
      id="content-start"
    >
      <transition-group
        name="list"
        tag="div"
        class="flex flex-col justify-center"
        :key="step.id"
      >
        <div v-for="row in rows" :key="row.id" class="draggable-row">
          <image-option-row
            v-if="row.type == 'IMAGE'"
            :key="row.id"
            :row_id="row.id"
            :survey="survey"
            :step="step"
            :dragActive="dragActive"
            v-on:open-modal="$emit('open-modal')"
          ></image-option-row>

          <content-row
            v-else
            :key="row.id"
            :row_id="row.id"
            :survey="survey"
            :step="step"
            :dragActive="dragActive"
          ></content-row>
        </div>
      </transition-group>
    </draggable>

    <!-- End Blocks -->

    <!--Add Content-->
    <div class="flex items-center justify-center">
      <div
        class="relative py-4 rounded-lg flex flex-col justify-center items-center"
      >
        <!-- Content Menu -
        <div
          v-if="showContentMenu"
          class="bg-gray-100 rounded pb-5 pl-5 border-gray-200 mt-5 absolute z-10"
        >
          <div class="flex flex-row-reverse">
            <div @click="showContentMenu = false">
              <svg-icon
                icon="heroicons/outline/x"
                class="w-4 h-4 text-gray-300 hover:text-gray-500 mt-1 mr-1 pb-1 cursor-pointer"
              />
            </div>
          </div>

          <div class="flex flex-row">
            <div
              class="border border-solid border-gray-200 cursor-pointer mr-5 w-20 h-20 bg-white rounded flex flex-col items-center justify-center hover:shadow-md"
              @click="addContentRow('TEXT')"
              @mouseenter="mouseenter('text')"
              @mouseleave="mouseleave"
            >
              <div
                class="mt-2 w-9 h-9 text-blue-400 p-1 rounded-full flex flex-col justify-center items-center"
                :class="{ 'bg-blue-100': hover == 'text' }"
              >
                <span class="material-icons">
                  title
                </span>
              </div>

              <div class="text-sm text-gray-700 mt-3">Text</div>
            </div>

            <div
              class="border border-solid border-gray-200 cursor-pointer mr-5 w-20 h-20 bg-white rounded flex flex-col items-center hover:shadow-md"
              @click="addContentRow('IMAGE')"
              @mouseenter="mouseenter('image')"
              @mouseleave="mouseleave"
            >
              <svg-icon
                icon="heroicons/outline/photograph"
                class="mt-2 w-9 h-9 text-blue-400 p-1 rounded-full"
                :class="{ 'bg-blue-100': hover == 'image' }"
              />

              <div class="text-sm text-gray-700 mt-3">Image</div>
            </div>

            <div
              class="border border-solid border-gray-200 cursor-pointer mr-5 w-20 h-20 bg-white rounded flex flex-col items-center hover:shadow-md"
              @click="addContentRow('BUTTON')"
              @mouseenter="mouseenter('button')"
              @mouseleave="mouseleave"
            >
              <svg-icon
                icon="misc/ok-button"
                class="mt-2 w-9 h-9 text-blue-400 p-1 rounded-full"
                :class="{ 'bg-blue-100': hover == 'button' }"
              />

              <div class="text-sm text-gray-700 mt-3">Button</div>
            </div>
          </div>

          
        <div class="flex flex-row mt-2">
          <div
            class="border border-solid border-gray-200 cursor-pointer mr-5 w-20 h-20 bg-white rounded flex flex-col items-center hover:shadow-md"
            @click="addContentRow('EMOJI')"
            @mouseenter="mouseenter('emoji')"
            @mouseleave="mouseleave"
          >
            <svg-icon
              icon="heroicons/outline/emoji-happy"
              class="mt-2 w-9 h-9 text-blue-400 p-1 rounded-full"
              :class="{ 'bg-blue-100': hover == 'emoji' }"
            />

            <div class="text-sm text-gray-700 mt-3">Emoji</div>
          </div>

          <div
            class="border border-solid border-gray-200 cursor-pointer mr-5 w-20 h-20 bg-white rounded flex flex-col items-center hover:shadow-md"
            @click="addContentRow('VIDEO')"
            @mouseenter="mouseenter('video')"
            @mouseleave="mouseleave"
          >
            <svg-icon
              icon="heroicons/outline/play"
              class="mt-2 w-9 h-9 text-blue-400  p-1 rounded-full"
              :class="{ 'bg-blue-100': hover == 'video' }"
            />

            <div class="text-sm text-gray-700 mt-3">Video</div>
          </div>

          <div
            class="border border-solid border-gray-200 cursor-pointer mr-5 w-20 h-20 bg-white rounded flex flex-col items-center hover:shadow-md"
            @click="addContentRow('FORM')"
            @mouseenter="mouseenter('form')"
            @mouseleave="mouseleave"
          >
            <svg-icon
              icon="misc/input"
              class="mt-2 w-9 h-9 text-blue-400 p-1 rounded-full"
              :class="{ 'bg-blue-100': hover == 'form' }"
            />

            <div class="text-sm text-gray-700 mt-3">Form field</div>
          </div>
        </div>

        </div>
        -->

        <div @click="addContentRow" class=" rounded-full">
          <svg-icon
            icon="heroicons/outline/plus"
            class="plus-icon bottom cursor-pointer text-purple-600 bg-white rounded-full"
            v-tooltip="'Add new row'"
          />
        </div>
      </div>
    </div>
    <!--End Add Content-->
  </div>
</template>

<script>
import Step from "@/models/Step";
import Content from "@/models/content/Content";
import Row from "@/models/content/Row";
import Column from "@/models/content/Column";
import { directive as onClickaway } from "vue-clickaway";
import { mixin as clickaway } from "vue-clickaway";
import { createPopper } from "@popperjs/core";

import ContentRow from "@/components/Content/ContentRow.vue";
import ImageOptionRow from "@/components/Content/ImageOptionRow.vue";
import Draggable from "vuedraggable";
import router from "@/router/route.js";

export default {
  directives: {
    onClickaway: onClickaway,
  },
  mixins: [clickaway],
  props: ["survey", "step"],
  data() {
    return {
      showContentMenu: false,
      //showContentPopover: false,
      dragActive: false,
      hover: null,
    };
  },
  components: {
    ContentRow,
    ImageOptionRow,
    Draggable,
  },
  computed: {
    rows: {
      get() {
        return this.step.rows;
      },
      set(rows) {
        var reorderedList = Row.reIndexList(rows);

        Row.update({
          data: reorderedList,
        });
      },
    },
    contentList() {
      return [{ type: "TEXT" }, { type: "BUTTON" }, { type: "IMAGE" }, { type: "VIDEO", name: "VIDEO (beta)" }, { type: "FIELD", name: "FORM FIELD (beta)" }, { type: "CODE", name: "CODE BLOCK (beta)" }];
    },
    chooserVisible: {
      get() {
        return this.$store.state.chooserVisible;
      },
      set(boolean) {
        this.$store.commit("SET_CHOOSER_STATE", boolean);
      },
    },
    bgColor() {
      return this.step.bgColor ?? this.survey.bgColor;
    },
  },
  methods: {
    closeChooser() {
      if (this.chooserVisible === true) {
        this.chooserVisible = false;
        //console.log("closing it");
      }
    },
    mouseenter(item) {
      this.hover = item;
    },
    mouseleave() {
      this.hover = null;
    },
    onDragStart: function(evt) {
      this.$store.commit("SET_DRAG_STATE", true);
      //this.dragActive = true;
    },
    onDragEnd: function(evt) {
      this.$store.commit("SET_DRAG_STATE", false);
      //this.dragActive = false;
    },
    getIcon(type) {
      if (type == "TEXT") return "title";
      if (type == "IMAGE") return "image";
      if (type == "BUTTON") return "picture_in_picture_alt";
      if (type == "FIELD") return "horizontal_rule";
      if (type == "CODE") return "code";
      if (type == "VIDEO") return "smart_display";

      else return "title";
    },
    /*
    async addContent(type, row_id) {
      await Row.insertNew({
        data: { type: type, row_id: row_id },
      });
    },
    */
    async addContentRow(type) {
      //create new column
      let column_id = Column.uuidv4();

      //create the container row and insert the content
      let row = await Row.insert({
        data: {
          id: Row.uuidv4(),
          parent_id: this.step.id,
          parent_type: "step",
          columns: [
            {
              id: column_id,
              //contents: [{ type: type, column_id: column_id }],
              contents: [],
            },
          ],
        },
      });

      this.showContentMenu = false;
    },
    async deleteContent(id) {
      Content.delete(id);
    },

    debounceClick: function(func) {
      if (this.timeout) clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        func();
      }, 200); // delay
    },
  },
  watch: {
    /*
    chooserVisible() {
      if (this.chooserVisible == true) {
        this.popper = createPopper(
          this.$refs.chooserButton,
          this.$refs.chooser,
          {
            placement: 'left',
          }
        );
      }
    },
    */
  },
};
</script>

<style>
.row-handle {
  position: absolute;
  cursor: move;
  bottom: 0;
  top: 0;
  left: 5px;
  margin-top: auto;
  margin-bottom: auto;
  height: 24px;
}
.plus-icon {
  font-size: 24px;
  width: 24px; /* Need a specific value to work */
  height: 24px;
  transition: all 0.15s ease-out 0s;
}
.plus-icon:hover {
  cursor: pointer;
  opacity: 1;
  font-size: 36px;
  width: 36px;
  height: 36px;
}
.plus-icon.right {
  position: absolute;
  top: 0;
  bottom: 0;
  right: -30px;
  margin-top: auto;
  margin-bottom: auto;
}
.plus-icon.right:hover {
  right: -36px;
}
.plus-icon.bottom {
  margin-right: auto;
  margin-left: auto;
}
.plus-icon.bottom:hover {
  margin-right: auto;
  margin-left: auto;
}

.chooser-ghost {
  border: 0px dashed rgb(203, 160, 204);
  border-radius: 00px;
  background: rgb(250, 233, 249);
  max-height: 0px;
}
.chooser-ghost div {
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.2s ease-out;
}
.slide-enter, .slide-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0.1;
  left: -100%;
}
</style>
